<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/warehouse/area/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item class="noborder" :label="$t('cangkubianma')">
						<el-input disabled v-model="$attrs.warehouse.code"></el-input>
					</el-form-item>
					<el-form-item class="noborder" :label="$t('cangkumingcheng')">
						<el-input disabled v-model="$attrs.warehouse.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('kuqubianma')">
						<el-input v-model="yt.conditions.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('kuqumingcheng')">
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{ $t('sousuo') }}
						</el-button>
						<el-button @click="yt.clear({ orderBy: 'code asc', warehouseId: $attrs.warehouse.id, })">{{
							$t('chongzhi') }}</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1'); setDefaultValue()" type="primary">
					{{ $t('xinzeng') }}
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-col :span="0.1">
							<el-button type="text" @click="yt.showEditDialog('kuwei', scope.row, 'w2')">{{ $t('kuwei')
							}}</el-button>
						</el-col>
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row, '/web/basic/warehouse/area/delete')">{{ $t('shanchu')
							}}</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('kuqubianma')" required>
						<el-input v-model.trim="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('kuqumingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shifoushouhuozancun')" required>
						<el-select v-model="yt.editObj.receiptStaging" @change="$forceUpdate()">
							<el-option :label="$t('fou')" :value="'0'"></el-option>
							<el-option :label="$t('shi')" :value="'1'"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST', '/web/basic/warehouse/area/create', beforeAdd)" type="primary">{{
							$t('baocun') }}
					</el-button>
				</span>
			</template>
			<!-- 编辑 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item class="noborder" :label="$t('kuqubianma')" required>
						<el-input disabled v-model.trim="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('kuqumingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shifoushouhuozancun')" required>
						<el-select v-model="yt.editObj.receiptStaging">
							<el-option :label="$t('fou')" :value="'0'"></el-option>
							<el-option :label="$t('shi')" :value="'1'"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST', '/web/basic/warehouse/area/update')" type="primary">{{ $t('baocun') }}
					</el-button>
				</span>
			</template>
			<!-- 库位 -->
			<template v-if="yt.editObj.action == 'kuwei'">
				<div class="dialog-scroller">
					<location :warehouse="$attrs.warehouse" :locatItem="yt.editObj"></location>
				</div>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
import location from '@@/pages/web/base/warehouse_model/location'
export default {
	name: 'web_base_warehouse_model_reservoir_area',
	components: {
		location
	},
	data() {
		return {
			columns: [{
				label: 'kuqubianma',
				prop: 'code',
				width: 130
			}, {
				label: 'kuqumingcheng',
				prop: 'name',
				width: 150
			},
			{
				label: 'shifoushouhuozancun',
				prop: 'receiptStaging',
				type: 'dictionary',
				key: 'SYSTEM_YES_NO',
				width: 150
			},
			{
				label: 'chuangjianren',
				prop: 'createByObject.nickname'
			},
			{
				label: 'chuangjianshijian',
				prop: 'createTime',
				type: 'time',
				width: 150
			},
			{
				label: 'caozuo',
				type: 'slot',
				width: 180,
				fixed: 'right'
			}
			]
		};
	},

	created() {
		setTimeout(() => {
			this.yt.conditions = {
				warehouseId: this.$attrs.warehouse.id,
			}
			this.yt.get(1)
		}, 300)
	},
	methods: {
		setDefaultValue() {
			this.yt.editObj.receiptStaging = '0';
		},
		beforeAdd(params, url) {
			params.warehouseId = this.$attrs.warehouse.id
			return params
		}
	}
};
</script>
